const _import = require("@/libs/util.import." + process.env.NODE_ENV)

export const routerName = {
  917: {
    path: "/salepre",
    name: "salepre",
    meta: {
      title: "权益",
      authId: "917",
      parentId: "1",
      cache: false
    }
  },
  91701: {
    path: "/beforeSale/checkSet",
    name: "beforeSaleCheckSet",
    meta: {
      title: "订单列表",
      authId: "91701",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/checkSet")
  },
  91702: {
    path: "/beforeSale/equitySummary",
    name: "equitySummary",
    meta: {
      title: "权益订单汇总",
      authId: "91702",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/equitySummary")
  },
  91703: {
    path: "/config/index",
    name: "configIndex",
    meta: {
      title: "开通配置",
      authId: "91703",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/config")
  },
  91704: {
    path: "/appointment",
    name: "appointment",
    meta: {
      title: "特别约定",
      authId: "91704",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/appointment")
  },
  91705: {
    path: "/addCode",
    name: "addCode",
    meta: {
      title: "核销码",
      authId: "91705",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/addCode")
  },
  91706: {
    path: "/claims",
    name: "claims",
    meta: {
      title: "核赔订单",
      authId: "91706",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/claims")
  },
  91707: {
    path: "/serviceConfig",
    name: "serviceConfig",
    meta: {
      title: "服务项目管理",
      authId: "91707",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/serviceConfig")
  },
  91708: {
    path: "/ContractManager",
    name: "ContractManager",
    meta: {
      title: "合同管理",
      authId: "91708",
      parentId: "917",
      cache: false
    },
    component: _import("salepre/ContractManager")
  }
}
